import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/ui-blocks/Reveal";
import { Button } from "@/components/ui/button";
import { Heart, HandHeart } from "lucide-react";

export const CTABand = () => (
  <section className="bg-background">
    <div className="container-wide py-16 lg:py-20">
      <Reveal>
        <div className="relative overflow-hidden rounded-2xl navy-band text-white p-8 md:p-12">
          <div className="absolute inset-0 grain" aria-hidden="true" />
          <div className="relative grid gap-6 md:grid-cols-2 items-center">
            <div>
              <div className="eyebrow text-[hsl(var(--orange))]">Join the movement</div>
              <h3 className="heading-2 text-white mt-2">Two minutes today can move a mountain tomorrow.</h3>
              <p className="text-white/85 mt-3 max-w-xl">Whether you volunteer 4 hours a month or contribute ₹1,000 — you become part of a real, verifiable impact story.</p>
            </div>
            <div className="flex flex-wrap md:justify-end gap-3">
              <Link to="/donate"><Button size="lg" className="bg-[hsl(var(--orange))] hover:bg-[hsl(var(--orange-2))] text-[hsl(var(--navy))] font-semibold h-12 px-6"><Heart className="h-4 w-4 mr-2" /> Donate Now</Button></Link>
              <Link to="/volunteer"><Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10 h-12 px-6"><HandHeart className="h-4 w-4 mr-2" /> Become a Volunteer</Button></Link>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
